// extracted by mini-css-extract-plugin
module.exports = {"infoValueContainer":"_uZ","color":"_u0","circle":"_u1"};